'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _UtmsToPath;

import AllowedUtms from './AllowedUtms';
var UtmsToPath = (_UtmsToPath = {}, _defineProperty(_UtmsToPath, AllowedUtms.UTM_SOURCE, 'utm_source'), _defineProperty(_UtmsToPath, AllowedUtms.UTM_MEDIUM, 'utm_medium'), _defineProperty(_UtmsToPath, AllowedUtms.UTM_ID, 'utm_id'), _UtmsToPath);
export default UtmsToPath;